'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiMessageTyping = function TiMessageTyping(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30 10h-21.7c-2.7 0-5 2.3-5 5v11.7c0 2.7 2.3 5 5 5h1.7v5l5-5h15c2.8 0 5-2.3 5-5v-11.7c0-2.7-2.2-5-5-5z m1.7 16.7c0 0.9-0.8 1.6-1.7 1.6h-21.7c-0.9 0-1.6-0.7-1.6-1.6v-11.7c0-0.9 0.7-1.7 1.6-1.7h21.7c0.9 0 1.7 0.8 1.7 1.7v11.7z m-20-2.5c-1.9 0-3.4-1.5-3.4-3.4s1.5-3.3 3.4-3.3 3.3 1.5 3.3 3.3-1.5 3.4-3.3 3.4z m0-5c-1 0-1.7 0.7-1.7 1.6s0.7 1.7 1.7 1.7 1.6-0.7 1.6-1.7-0.7-1.6-1.6-1.6z m7.5 5c-1.9 0-3.4-1.5-3.4-3.4s1.5-3.3 3.4-3.3 3.3 1.5 3.3 3.3-1.5 3.4-3.3 3.4z m0-5c-1 0-1.7 0.7-1.7 1.6s0.7 1.7 1.7 1.7 1.6-0.7 1.6-1.7-0.7-1.6-1.6-1.6z m7.5 5c-1.9 0-3.4-1.5-3.4-3.4s1.5-3.3 3.4-3.3 3.3 1.5 3.3 3.3-1.5 3.4-3.3 3.4z m0-5c-1 0-1.7 0.7-1.7 1.6s0.7 1.7 1.7 1.7 1.6-0.7 1.6-1.7-0.7-1.6-1.6-1.6z' })
        )
    );
};

exports.default = TiMessageTyping;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/message-typing.js
// module id = 3696
// module chunks = 0